<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <EngagementNav></EngagementNav>
        </b-col>
      </b-row>
    </div>
    <div id="notifications-tab" class="engagement-body px-5">
        <b-row>
            <b-col cols="3">
                <div id="shadow-wrapper" class="rounded bg-white">
                    <div id="notifications-nav">
                        <h1 class="px-4 py-3 mb-0">All Channels</h1>
                        <b-nav vertical>
                            <b-nav-item href="#"  @click="switchChannel(channel)" :active="nav == channel.channel_name ? true : false" v-for="channel in channelList" :key="channel.channel_uuid">
                                <template v-if="channel.channel_name == 'SMS'">
                                    <img src="@/assets/images/icons/notif-sms.svg" alt="Notification SMS Icon" class="mr-2">
                                </template>
                                <template v-else-if="channel.channel_name == 'In-App Message'">
                                    <img src="@/assets/images/icons/notif-in-app-message.svg" alt="Notification In-App Message" class="mr-2">
                                </template>
                                <template v-else-if="channel.channel_name == 'Email'">
                                    <img src="@/assets/images/icons/notif-email.svg" alt="Notification SMS Icon" class="mr-2">
                                </template>
                                {{ channel.channel_name }}
                            </b-nav-item>
                        </b-nav>
                        <div class="px-4 py-3 d-none">
                            <b-button id="add-more-channel" variant="primary" block>
                                <img src="@/assets/images/plus-icon.svg" alt="Add">
                                Add More Channel
                            </b-button>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col cols="9">
                <Channel 
                    :loading="loading"
                    :selectedChannel="selectedChannel"
                    :selectedNotificationCategory="selectedNotificationCategory"
                    :notificationCategories="notificationCategories"
                    :notificationTemplates="notificationTemplates"
                ></Channel>
            </b-col>
        </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EngagementNav from "./EngagementNav.vue";
import Channel from "./notifications/Channel.vue";
export default {
    name: "NewsAndPopUp",
    components: {
        EngagementNav,
        Channel
    },
    computed: {
        ...mapState("engagementNotifications", [
            "loading",
            "errors",
            "channelList",
            "selectedChannel",
            "notificationCategories",
            "selectedNotificationCategory",
            "notificationTemplates"
        ])
    },
    data() {
        return {
            nav: "SMS",
            channels: {
                SMS: {
                    title: "SMS",
                    enabled: true,
                    selectedTab: "Customer Registration",
                    tabs: {
                        "Customer Registration": {
                            notifications: {
                                "One Time PIN": {
                                    enabled: true,
                                    standard:
                                        "Your verification code is <span style='color: #5182ff;'>&lt;OTP PIN&gt;</span>. For your protection, do not share this code with anyone.",
                                    customized: ""
                                },
                                "Welcome SMS": {
                                    enabled: true,
                                    standard:
                                        "Your verification code is <span style='color: #5182ff;'>&lt;OTP PIN&gt;</span>. For your protection, do not share this code with anyone.",
                                    customized: ""
                                }
                            }
                        },
                        "Points Earning": {
                            notifications: {
                                "Points Earned": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                },
                                "Issued / Claimed Reward": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                },
                                "Redeem Reward": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                }
                            }
                        },
                        "Points Transfer": {
                            notifications: {
                                "Points Transfer - Sender": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                },
                                "Points Transfer - Receiver": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                }
                            }
                        }
                    }
                },
                "In-App Message": {
                    title: "In-App Message",
                    enabled: true,
                    selectedTab: "Customer Registration",
                    tabs: {
                        "Customer Registration": {
                            notifications: {
                                "One Time PIN": {
                                    enabled: true,
                                    standard:
                                        "Your verification code is <span style='color: #5182ff;'>&lt;OTP PIN&gt;</span>. For your protection, do not share this code with anyone.",
                                    customized: ""
                                },
                                "Welcome SMS": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                }
                            }
                        },
                        "Points Earning": {
                            notifications: {
                                "Points Earned": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                },
                                "Issued / Claimed Reward": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                },
                                "Redeem Reward": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                }
                            }
                        },
                        "Points Transfer": {
                            notifications: {
                                "Points Transfer - Sender": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                },
                                "Points Transfer - Receiver": {
                                    enabled: true,
                                    standard: "",
                                    customized: ""
                                }
                            }
                        }
                    }
                },
                Email: {
                    title: "Email",
                    enabled: true,
                    selectedTab: "",
                    tabs: {}
                }
            },
            variableMenu: false,
            isNotificationEnabled: true,
            isContentEditableEnabled: false,
            list1: [
                { name: "John", id: 1, draggable: false },
                { name: "Joao", id: 2, draggable: false },
                { name: "Jean", id: 3, draggable: false },
                { name: "Gerard", id: 4, draggable: true }
            ],
            list2: [
                { name: "Juan", id: 5 },
                { name: "Edgard", id: 6 },
                { name: "Johnson", id: 7 }
            ]
        };
    },
    methods: {
        add: function() {
            this.list.push({ name: "Juan" });
        },
        replace: function() {
            this.list = [{ name: "Edgard" }];
        },
        clone: function(el) {
            return {
                name: el.name + " cloned"
            };
        },
        log: function(evt) {
            window.console.log(evt);
        },
        getChanneList: function() {
            // Get Channel List
            let _this = this;
            this.$store
                .dispatch("engagementNotifications/getChannelList")
                .then(function() {
                    // Get Notification Categories
                    _this.$store
                        .dispatch(
                            "engagementNotifications/getNotificationCategories"
                        )
                        .then(function() {
                            if (
                                _this.selectedChannel != null &&
                                _this.selectedNotificationCategory != null
                            ) {
                                let param = {
                                    channel_uuid:
                                        _this.selectedChannel.channel_uuid,
                                    category_uuid:
                                        _this.selectedNotificationCategory.uuid
                                };
                                _this.$store.dispatch(
                                    "engagementNotifications/getNotificationTemplates",
                                    param
                                );
                            }
                        });
                });
        },
        switchChannel: function(channel) {
            this.nav = channel.channel_name;
            let _this = this;
            this.$store
                .dispatch("engagementNotifications/setSelectedChannel", channel)
                .then(function() {
                    if (
                        _this.selectedChannel != null &&
                        _this.selectedNotificationCategory != null
                    ) {
                        let param = {
                            channel_uuid: _this.selectedChannel.channel_uuid,
                            category_uuid:
                                _this.selectedNotificationCategory.uuid
                        };
                        _this.$store.dispatch(
                            "engagementNotifications/getNotificationTemplates",
                            param
                        );
                    }
                });
        }
    },
    created() {
        this.getChanneList();
    }
};
</script>
